





















import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import Judge from '@/evaluations/entities/judge'

@Component
export default class JudgeFormOptional extends Vue {
  @Prop()
  private value!: Judge

  private model = this.value

  @Watch('value')
  private valueUpdated(val: Judge, old: Judge) {
    this.model = val
  }
}
